import { useEffect, useState } from "react";
import "@/components/CinematicBook.css";

/**
 * CSS-only 3D open book on a wooden table. Pages flip in sequence, then the
 * final page reveals the tagline: "Unfinished to Finished — join Bookforge."
 */
export default function CinematicBook({ authorName, bookTitle }) {
  const [phase, setPhase] = useState(0);
  const displayName = (authorName && authorName.trim()) || "Your Name";
  const displayTitle = (bookTitle && bookTitle.trim()) || "";

  useEffect(() => {
    const timeouts = [
      setTimeout(() => setPhase(1), 800),   // first page flips
      setTimeout(() => setPhase(2), 1900),  // second flip
      setTimeout(() => setPhase(3), 3000),  // third flip
      setTimeout(() => setPhase(4), 4200),  // final page — text appears
    ];
    return () => timeouts.forEach(clearTimeout);
  }, []);

  return (
    <div className="bf-book-stage" data-testid="cinematic-book">
      <div className="bf-book-table" />
      <div className="bf-book" data-phase={phase}>
        <div className="bf-book-shadow" />
        <div className="bf-book-cover-left" />
        <div className="bf-book-cover-right" />
        <div className="bf-book-spine" />

        {/* Static base pages */}
        <div className="bf-page bf-page-static bf-page-left" />
        <div className="bf-page bf-page-static bf-page-right">
          {phase >= 4 && (
            <div className="bf-final-text" data-testid="cinematic-final-text">
              <p className="bf-final-eyebrow">From</p>
              <p className="bf-final-strike">Unfinished</p>
              <p className="bf-final-to">to</p>
              <p className="bf-final-done">Finished.</p>
              {displayTitle && (
                <p className="bf-final-booktitle" data-testid="cinematic-book-title">
                  &ldquo;{displayTitle}&rdquo;
                </p>
              )}
              <p className="bf-final-author" data-testid="cinematic-author">
                <span className="bf-final-author-label">Author :</span>{" "}
                <span className="bf-final-author-name">{displayName}</span>
              </p>
              <p className="bf-final-sub">Join Book-Forge — your book writing companion.</p>
            </div>
          )}
        </div>

        {/* Three flipping pages */}
        <div className={`bf-page bf-page-flip bf-page-1 ${phase >= 1 ? "flipped" : ""}`}>
          <div className="bf-page-face bf-page-front">
            <div className="bf-page-lines" />
          </div>
          <div className="bf-page-face bf-page-back">
            <div className="bf-page-lines bf-page-lines--filled" />
          </div>
        </div>
        <div className={`bf-page bf-page-flip bf-page-2 ${phase >= 2 ? "flipped" : ""}`}>
          <div className="bf-page-face bf-page-front">
            <div className="bf-page-lines" />
          </div>
          <div className="bf-page-face bf-page-back">
            <div className="bf-page-lines bf-page-lines--filled" />
          </div>
        </div>
        <div className={`bf-page bf-page-flip bf-page-3 ${phase >= 3 ? "flipped" : ""}`}>
          <div className="bf-page-face bf-page-front">
            <div className="bf-page-lines" />
          </div>
          <div className="bf-page-face bf-page-back">
            <div className="bf-page-lines bf-page-lines--filled" />
          </div>
        </div>

        {/* Breeze particles */}
        <div className="bf-breeze">
          <span /><span /><span /><span /><span />
        </div>
      </div>
    </div>
  );
}
